import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const getMostRecentAIContentInput = z.object({
  teamId: z.string(),
  contentType: z.string(),
});

const getMostRecentAIContentOutput = z.object({
  content: z.string().nullable(),
});

export const getMostRecentAIContent = unaryRpc({
  name: "getMostRecentAIContent",
  input: getMostRecentAIContentInput,
  output: getMostRecentAIContentOutput,
});
